import {
    Directive,
    Input,
    Output,
    EventEmitter,
    TemplateRef,
    ViewContainerRef,
    HostListener,
    HostBinding
} from '@angular/core';

@Directive({
    selector: '[appMatDetailRow]'
})
export class MatDetailRowDirective {
    private _row: any;
    private _templateRef: TemplateRef<any>;
    private _opened: boolean;
    private _toggling: boolean;

    @Input()
    set appMatDetailRowOpened(value: any) {
        if (value) {
            this.show();
        } else {
            this.hide();
        }
    }

    @Input()
    set appMatDetailRow(value: any) {
        if (value !== this._row) {
            this._row = value;
        }
    }

    @Input()
    set appMatDetailRowTpl(value: TemplateRef<any>) {
        if (value !== this._templateRef) {
            this._templateRef = value;
        }
    }

    @Output() expand: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('click', [])
    onClick(): void {
        if (!this._opened) {
            this._toggling = true;
            this.expand.emit(() => {
                this._toggling = false;
                this.toggle();
            });
        } else {
            this.toggle();
        }
    }

    @HostBinding('class.expanded')
    get expended(): boolean {
        return this._opened;
    }

    @HostBinding('class.toggling')
    get toggling(): boolean {
        return this._toggling;
    }

    constructor(
        private _viewContainerRef: ViewContainerRef
    ) {
        this.toggle();
    }

    private hide() {
        this._viewContainerRef.clear();
        this._opened = this._viewContainerRef.length > 0;
    }

    private show() {
        this._viewContainerRef.clear();

        if (this._templateRef && this._row) {
            this._viewContainerRef.createEmbeddedView(this._templateRef, {
                $implicit: this._row,
                onCollapse: () => this.hide()
            });
        }

        this._opened = this._viewContainerRef.length > 0;
    }

    toggle(): void {
        if (this._opened) {
            this.hide();
        } else {
            this.show();
        }
    }
}
